import { isIosUnder13Version } from 'common/utils/checkBrowserType';
import { svgToDataURL } from 'common/utils/index';

import getDefaultClusterIcon from '../assets/mapIcons/cluster/default';
import defaultClusterIcon from '../assets/mapIcons/cluster/default/default.png';
import getLargestClusterIcon from '../assets/mapIcons/cluster/largest';
import largestClusterIcon from '../assets/mapIcons/cluster/largest/largest.png';

import commonStationIcon from '../assets/mapIcons/stations/common/default.png';
import commonFavouriteStationIcon from '../assets/mapIcons/stations/common/favourite.png';
import commonActionStationIcon from '../assets/mapIcons/stations/common/action.png';
import commonActiveStationIcon from '../assets/mapIcons/stations/common/active.png';
import commonActiveFavouriteStationIcon from '../assets/mapIcons/stations/common/activeFavourite.png';
import commonActiveActionStationIcon from '../assets/mapIcons/stations/common/activeAction.png';

import discountStationIcon from '../assets/mapIcons/stations/discount/default.png';
import discountFavouriteStationIcon from '../assets/mapIcons/stations/discount/favourite.png';
import discountActionStationIcon from '../assets/mapIcons/stations/discount/action.png';
import discountActiveStationIcon from '../assets/mapIcons/stations/discount/active.png';
import discountActiveFavouriteStationIcon from '../assets/mapIcons/stations/discount/activeFavourite.png';
import discountActiveActionStationIcon from '../assets/mapIcons/stations/discount/activeAction.png';

import powerMaxStationIcon from '../assets/mapIcons/stations/powerMax/default.png';
import powerMaxFavouriteStationIcon from '../assets/mapIcons/stations/powerMax/favourite.png';
import powerMaxActionStationIcon from '../assets/mapIcons/stations/powerMax/action.png';
import powerMaxActiveStationIcon from '../assets/mapIcons/stations/powerMax/active.png';
import powerMaxActiveFavouriteStationIcon from '../assets/mapIcons/stations/powerMax/activeFavourite.png';
import powerMaxActiveActionStationIcon from '../assets/mapIcons/stations/powerMax/activeAction.png';

import economyStationIcon from '../assets/mapIcons/stations/economy/default.png';
import economyFavouriteStationIcon from '../assets/mapIcons/stations/economy/favourite.png';
import economyActionStationIcon from '../assets/mapIcons/stations/economy/action.png';
import economyActiveStationIconfrom from  '../assets/mapIcons/stations/economy/active.png';
import economyActiveFavouriteStationIconfrom from  '../assets/mapIcons/stations/economy/activeFavourite.png';
import economyActiveActionStationIconfrom from  '../assets/mapIcons/stations/economy/activeAction.png';

// Roadside services
import roadPaymentPointServiceIcon from '../assets/mapIcons/roadsideServices/roadPaymentPoint/default.png';
import roadPaymentPointServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/roadPaymentPoint/favourite.png';
import roadPaymentPointActionServiceIcon from '../assets/mapIcons/roadsideServices/roadPaymentPoint/action.png';
import roadPaymentPointActiveServiceIcon from  '../assets/mapIcons/roadsideServices/roadPaymentPoint/active.png';
import roadPaymentPointActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/roadPaymentPoint/activeFavourite.png';
import roadPaymentPointActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/roadPaymentPoint/activeAction.png';

import parkingServiceIcon from '../assets/mapIcons/roadsideServices/parking/default.png';
import parkingServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/parking/favourite.png';
import parkingActionServiceIcon from '../assets/mapIcons/roadsideServices/parking/action.png';
import parkingActiveServiceIcon from  '../assets/mapIcons/roadsideServices/parking/active.png';
import parkingActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/parking/activeFavourite.png';
import parkingActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/parking/activeAction.png';

import carWashServiceIcon from '../assets/mapIcons/roadsideServices/carWash/default.png';
import carWashServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/carWash/favourite.png';
import carWashActionServiceIcon from '../assets/mapIcons/roadsideServices/carWash/action.png';
import carWashActiveServiceIcon from  '../assets/mapIcons/roadsideServices/carWash/active.png';
import carWashActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/carWash/activeFavourite.png';
import carWashActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/carWash/activeAction.png';

import evChargingServiceIcon from '../assets/mapIcons/roadsideServices/evCharging/default.png';
import evChargingServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/evCharging/favourite.png';
import evChargingActiveServiceIcon from  '../assets/mapIcons/roadsideServices/evCharging/active.png';
import evChargingActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/evCharging/activeFavourite.png';

import onlineBookingParkingServiceIcon from '../assets/mapIcons/roadsideServices/onlineBookingParking/default.png';
import onlineBookingParkingServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/onlineBookingParking/favourite.png';
import onlineBookingParkingActiveServiceIcon from  '../assets/mapIcons/roadsideServices/onlineBookingParking/active.png';
import onlineBookingParkingActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/onlineBookingParking/activeFavourite.png';

import carServiceServiceIcon from '../assets/mapIcons/roadsideServices/carService/default.png';
import carServiceServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/carService/favourite.png';
import carServiceActionServiceIcon from '../assets/mapIcons/roadsideServices/carService/action.png';
import carServiceActiveServiceIcon from  '../assets/mapIcons/roadsideServices/carService/active.png';
import carServiceActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/carService/activeFavourite.png';
import carServiceActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/carService/activeAction.png';

import convoyServiceIcon from '../assets/mapIcons/roadsideServices/convoy/default.png';
import convoyServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/convoy/favourite.png';
import convoyActionServiceIcon from '../assets/mapIcons/roadsideServices/convoy/action.png';
import convoyActiveServiceIcon from  '../assets/mapIcons/roadsideServices/convoy/active.png';
import convoyActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/convoy/activeFavourite.png';
import convoyActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/convoy/activeAction.png';

import ferryboatServiceIcon from '../assets/mapIcons/roadsideServices/ferryboat/default.png';
import ferryboatServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/ferryboat/favourite.png';
import ferryboatActionServiceIcon from '../assets/mapIcons/roadsideServices/ferryboat/action.png';
import ferryboatActiveServiceIcon from  '../assets/mapIcons/roadsideServices/ferryboat/active.png';
import ferryboatActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/ferryboat/activeFavourite.png';
import ferryboatActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/ferryboat/activeAction.png';

import railwayServiceIcon from '../assets/mapIcons/roadsideServices/railway/default.png';
import railwayServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/railway/favourite.png';
import railwayActionServiceIcon from '../assets/mapIcons/roadsideServices/railway/action.png';
import railwayActiveServiceIcon from  '../assets/mapIcons/roadsideServices/railway/active.png';
import railwayActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/railway/activeFavourite.png';
import railwayActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/railway/activeAction.png';

import autoPartsStoreServiceIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/default.png';
import autoPartsStoreServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/favourite.png';
import autoPartsStoreActionServiceIcon from '../assets/mapIcons/roadsideServices/autoPartsStore/action.png';
import autoPartsStoreActiveServiceIcon from  '../assets/mapIcons/roadsideServices/autoPartsStore/active.png';
import autoPartsStoreActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/autoPartsStore/activeFavourite.png';
import autoPartsStoreActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/autoPartsStore/activeAction.png';

import cafeServiceIcon from '../assets/mapIcons/roadsideServices/cafe/default.png';
import cafeServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/cafe/favourite.png';
import cafeActionServiceIcon from '../assets/mapIcons/roadsideServices/cafe/action.png';
import cafeActiveServiceIcon from  '../assets/mapIcons/roadsideServices/cafe/active.png';
import cafeActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/cafe/activeFavourite.png';
import cafeActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/cafe/activeAction.png';

import truckWashServiceIcon from '../assets/mapIcons/roadsideServices/truckWash/default.png';
import truckWashServiceFavouriteIcon from '../assets/mapIcons/roadsideServices/truckWash/favourite.png';
import truckWashActionServiceIcon from '../assets/mapIcons/roadsideServices/truckWash/action.png';
import truckWashActiveServiceIcon from  '../assets/mapIcons/roadsideServices/truckWash/active.png';
import truckWashActiveFavouriteServiceIcon from  '../assets/mapIcons/roadsideServices/truckWash/activeFavourite.png';
import truckWashActiveActionServiceIcon from  '../assets/mapIcons/roadsideServices/truckWash/activeAction.png';

import {
  MARKER_HEIGHT,
  ACTIVE_MARKER_HEIGHT,
  ACTIVE_MARKER_WIDTH,
  CLUSTER_HEIGHT,
  CLUSTER_WIDTH,
  LARGEST_CLUSTER_HEIGHT,
  LARGET_CLUSTER_WIDTH,
  MARKER_WIDTH
} from '../constants';


export const getMarkerSettings = (iconURL: string, id?: string) => () => ({
  url: iconURL,
  height: MARKER_HEIGHT,
  width: MARKER_WIDTH,
  anchorY: MARKER_HEIGHT,
  anchorX: MARKER_WIDTH * 0.5,
  id
});

export const getActiveMarkerSettings = (iconURL: string, id?: string) => () => ({
  url: iconURL,
  height: ACTIVE_MARKER_HEIGHT,
  width: ACTIVE_MARKER_WIDTH,
  anchorY: ACTIVE_MARKER_HEIGHT,
  anchorX: ACTIVE_MARKER_WIDTH * 0.5,
  id
});

export const getClusterSettings = () => ({ clusterWeight }: any) => ({
  url: isIosUnder13Version ? defaultClusterIcon : svgToDataURL(getDefaultClusterIcon(clusterWeight)),
  width: CLUSTER_WIDTH,
  height: CLUSTER_HEIGHT,
  anchorY: CLUSTER_HEIGHT,
  anchorX: CLUSTER_WIDTH * 0.5,
  id: `cluster-${clusterWeight}`
});

export const getLargestClusterSettings = () => ({ clusterWeight }: any) => ({
  url: isIosUnder13Version ? largestClusterIcon : svgToDataURL(getLargestClusterIcon(clusterWeight)),
  width: LARGET_CLUSTER_WIDTH,
  height: LARGEST_CLUSTER_HEIGHT,
  anchorY: LARGEST_CLUSTER_HEIGHT,
  anchorX: LARGET_CLUSTER_WIDTH * 0.5,
  id: `large-cluster-${clusterWeight}`
});

const ICONS = {
  cluster: getClusterSettings(),
  largeCluster: getLargestClusterSettings(),
  station1: getMarkerSettings(commonStationIcon, 'station1'),
  station2: getMarkerSettings(discountStationIcon, 'station2'),
  station4: getMarkerSettings(powerMaxStationIcon, 'station4'),
  station5: getMarkerSettings(economyStationIcon, 'station5'),
  stationFavourite1: getMarkerSettings(commonFavouriteStationIcon, 'stationFavourite1'),
  stationFavourite2: getMarkerSettings(discountFavouriteStationIcon, 'stationFavourite2'),
  stationFavourite4: getMarkerSettings(powerMaxFavouriteStationIcon, 'stationFavourite4'),
  stationFavourite5: getMarkerSettings(economyFavouriteStationIcon, 'stationFavourite5'),
  stationAction1: getMarkerSettings(commonActionStationIcon, 'stationAction1'),
  stationAction2: getMarkerSettings(discountActionStationIcon, 'stationAction2'),
  stationAction4: getMarkerSettings(powerMaxActionStationIcon, 'stationAction4'),
  stationAction5: getMarkerSettings(economyActionStationIcon, 'stationAction5'),
  stationActive1: getActiveMarkerSettings(commonActiveStationIcon, 'stationActive1'),
  stationActive2: getActiveMarkerSettings(discountActiveStationIcon, 'stationActive2'),
  stationActive4: getActiveMarkerSettings(powerMaxActiveStationIcon, 'stationActive4'),
  stationActive5: getActiveMarkerSettings(economyActiveStationIconfrom, 'stationActive5'),
  stationActiveAction1: getActiveMarkerSettings(commonActiveActionStationIcon, 'stationActiveAction1'),
  stationActiveAction2: getActiveMarkerSettings(discountActiveActionStationIcon, 'stationActiveAction2'),
  stationActiveAction4: getActiveMarkerSettings(powerMaxActiveActionStationIcon, 'stationActiveAction4'),
  stationActiveAction5: getActiveMarkerSettings(economyActiveActionStationIconfrom, 'stationActiveAction5'),
  stationActiveFavourite1: getActiveMarkerSettings(commonActiveFavouriteStationIcon, 'stationActiveFavourite1'),
  stationActiveFavourite2: getActiveMarkerSettings(discountActiveFavouriteStationIcon, 'stationActiveFavourite2'),
  stationActiveFavourite4: getActiveMarkerSettings(powerMaxActiveFavouriteStationIcon, 'stationActiveFavourite4'),
  stationActiveFavourite5: getActiveMarkerSettings(economyActiveFavouriteStationIconfrom, 'stationActiveFavourite5'),
  roadsideService2: getMarkerSettings(roadPaymentPointServiceIcon, 'roadsideService2'),
  roadsideService3: getMarkerSettings(parkingServiceIcon, 'roadsideService3'),
  roadsideService4: getMarkerSettings(carWashServiceIcon, 'roadsideService4'),
  roadsideService5: getMarkerSettings(carServiceServiceIcon, 'roadsideService5'),
  roadsideService6: getMarkerSettings(convoyServiceIcon, 'roadsideService6'),
  roadsideService7: getMarkerSettings(ferryboatServiceIcon, 'roadsideService7'),
  roadsideService8: getMarkerSettings(railwayServiceIcon, 'roadsideService8'),
  roadsideService9: getMarkerSettings(autoPartsStoreServiceIcon, 'roadsideService9'),
  roadsideService10: getMarkerSettings(cafeServiceIcon, 'roadsideService10'),
  roadsideService11: getMarkerSettings(truckWashServiceIcon, 'roadsideService11'),
  roadsideService12: getMarkerSettings(carWashServiceIcon, 'roadsideService12'),
  roadsideService13: getMarkerSettings(evChargingServiceIcon, 'roadsideService13'),
  roadsideService14: getMarkerSettings(onlineBookingParkingServiceIcon, 'roadsideService14'),
  roadsideServiceFavourite2: getMarkerSettings(roadPaymentPointServiceFavouriteIcon, 'roadsideServiceFavourite2'),
  roadsideServiceFavourite3: getMarkerSettings(parkingServiceFavouriteIcon, 'roadsideServiceFavourite3'),
  roadsideServiceFavourite4: getMarkerSettings(carWashServiceFavouriteIcon, 'roadsideServiceFavourite4'),
  roadsideServiceFavourite5: getMarkerSettings(carServiceServiceFavouriteIcon, 'roadsideServiceFavourite5'),
  roadsideServiceFavourite6: getMarkerSettings(convoyServiceFavouriteIcon, 'roadsideServiceFavourite6'),
  roadsideServiceFavourite7: getMarkerSettings(ferryboatServiceFavouriteIcon, 'roadsideServiceFavourite7'),
  roadsideServiceFavourite8: getMarkerSettings(railwayServiceFavouriteIcon, 'roadsideServiceFavourite8'),
  roadsideServiceFavourite9: getMarkerSettings(autoPartsStoreServiceFavouriteIcon, 'roadsideServiceFavourite9'),
  roadsideServiceFavourite10: getMarkerSettings(cafeServiceFavouriteIcon, 'roadsideServiceFavourite10'),
  roadsideServiceFavourite11: getMarkerSettings(truckWashServiceFavouriteIcon, 'roadsideServiceFavourite11'),
  roadsideServiceFavourite12: getMarkerSettings(carWashServiceFavouriteIcon, 'roadsideServiceFavourite12'),
  roadsideServiceFavourite13: getMarkerSettings(evChargingServiceFavouriteIcon, 'roadsideServiceFavourite13'),
  roadsideServiceFavourite14: getMarkerSettings(onlineBookingParkingServiceFavouriteIcon, 'roadsideServiceFavourite14'),
  roadsideServiceAction2: getMarkerSettings(roadPaymentPointActionServiceIcon, 'roadsideServiceAction2'),
  roadsideServiceAction3: getMarkerSettings(parkingActionServiceIcon, 'roadsideServiceAction3'),
  roadsideServiceAction4: getMarkerSettings(carWashActionServiceIcon, 'roadsideServiceAction4'),
  roadsideServiceAction5: getMarkerSettings(carServiceActionServiceIcon, 'roadsideServiceAction5'),
  roadsideServiceAction6: getMarkerSettings(convoyActionServiceIcon, 'roadsideServiceAction6'),
  roadsideServiceAction7: getMarkerSettings(ferryboatActionServiceIcon, 'roadsideServiceAction7'),
  roadsideServiceAction8: getMarkerSettings(railwayActionServiceIcon, 'roadsideServiceAction8'),
  roadsideServiceAction9: getMarkerSettings(autoPartsStoreActionServiceIcon, 'roadsideServiceAction9'),
  roadsideServiceAction10: getMarkerSettings(cafeActionServiceIcon, 'roadsideServiceAction10'),
  roadsideServiceAction11: getMarkerSettings(truckWashActionServiceIcon, 'roadsideServiceAction11'),
  roadsideServiceAction12: getMarkerSettings(carWashActionServiceIcon, 'roadsideServiceAction12'),
  roadsideServiceActive2: getActiveMarkerSettings(roadPaymentPointActiveServiceIcon, 'roadsideServiceActive2'),
  roadsideServiceActive3: getActiveMarkerSettings(parkingActiveServiceIcon, 'roadsideServiceActive3'),
  roadsideServiceActive4: getActiveMarkerSettings(carWashActiveServiceIcon, 'roadsideServiceActive4'),
  roadsideServiceActive5: getActiveMarkerSettings(carServiceActiveServiceIcon, 'roadsideServiceActive5'),
  roadsideServiceActive6: getActiveMarkerSettings(convoyActiveServiceIcon, 'roadsideServiceActive6'),
  roadsideServiceActive7: getActiveMarkerSettings(ferryboatActiveServiceIcon, 'roadsideServiceActive7'),
  roadsideServiceActive8: getActiveMarkerSettings(railwayActiveServiceIcon, 'roadsideServiceActive8'),
  roadsideServiceActive9: getActiveMarkerSettings(autoPartsStoreActiveServiceIcon, 'roadsideServiceActive9'),
  roadsideServiceActive10: getActiveMarkerSettings(cafeActiveServiceIcon, 'roadsideServiceActive10'),
  roadsideServiceActive11: getActiveMarkerSettings(truckWashActiveServiceIcon, 'roadsideServiceActive11'),
  roadsideServiceActive12: getActiveMarkerSettings(carWashActiveServiceIcon, 'roadsideServiceActive12'),
  roadsideServiceActive13: getActiveMarkerSettings(evChargingActiveServiceIcon, 'roadsideServiceActive13'),
  roadsideServiceActive14: getActiveMarkerSettings(onlineBookingParkingActiveServiceIcon, 'roadsideServiceActive14'),
  roadsideServiceActiveFavourite2: getActiveMarkerSettings(roadPaymentPointActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite3: getActiveMarkerSettings(parkingActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite4: getActiveMarkerSettings(carWashActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite5: getActiveMarkerSettings(carServiceActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite6: getActiveMarkerSettings(convoyActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite7: getActiveMarkerSettings(ferryboatActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite8: getActiveMarkerSettings(railwayActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite9: getActiveMarkerSettings(autoPartsStoreActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite10: getActiveMarkerSettings(cafeActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite11: getActiveMarkerSettings(truckWashActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite12: getActiveMarkerSettings(carWashActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite13: getActiveMarkerSettings(evChargingActiveFavouriteServiceIcon),
  roadsideServiceActiveFavourite14: getActiveMarkerSettings(onlineBookingParkingActiveFavouriteServiceIcon),
  roadsideServiceActiveAction2: getActiveMarkerSettings(roadPaymentPointActiveActionServiceIcon, 'roadsideServiceActiveAction2'),
  roadsideServiceActiveAction3: getActiveMarkerSettings(parkingActiveActionServiceIcon, 'roadsideServiceActiveAction3'),
  roadsideServiceActiveAction4: getActiveMarkerSettings(carWashActiveActionServiceIcon, 'roadsideServiceActiveAction4'),
  roadsideServiceActiveAction5: getActiveMarkerSettings(carServiceActiveActionServiceIcon, 'roadsideServiceActiveAction5'),
  roadsideServiceActiveAction6: getActiveMarkerSettings(convoyActiveActionServiceIcon, 'roadsideServiceActiveAction6'),
  roadsideServiceActiveAction7: getActiveMarkerSettings(ferryboatActiveActionServiceIcon, 'roadsideServiceActiveAction7'),
  roadsideServiceActiveAction8: getActiveMarkerSettings(railwayActiveActionServiceIcon, 'roadsideServiceActiveAction8'),
  roadsideServiceActiveAction9: getActiveMarkerSettings(autoPartsStoreActiveActionServiceIcon, 'roadsideServiceActiveAction9'),
  roadsideServiceActiveAction10: getActiveMarkerSettings(cafeActiveActionServiceIcon, 'roadsideServiceActiveAction10'),
  roadsideServiceActiveAction11: getActiveMarkerSettings(truckWashActiveActionServiceIcon, 'roadsideServiceActiveAction11'),
  roadsideServiceActiveAction12: getActiveMarkerSettings(carWashActiveActionServiceIcon, 'roadsideServiceActiveAction12')
} as Record<string, any>;

export const getMapStationIconSettings = (markerName: string, props: any) => (
  ICONS[markerName] ? ICONS[markerName](props) : ICONS.station1(props)
);
